import { css, styled } from '../../../common.styles';

export const Div = styled.div``;

export const Grid = styled.div`
  display: grid;
`;

export const Flex = styled.div`
  display: flex;
`;

export const Row = styled(Flex)<{ gap?: number; marginTop?: number }>`
  flex-flow: row nowrap;
  ${(p) =>
    p.gap
      ? css`
          gap: ${p.gap}px;
        `
      : ''};
  ${(p) =>
    p.marginTop
      ? css`
          margin-top: ${p.marginTop}px;
        `
      : ''};
`;

export const CenterAlignedRow = styled(Row)`
  flex-flow: row nowrap;
  align-items: center;
`;

export const SpaceBetweenRow = styled(Row)`
  justify-content: space-between;
  align-items: center;
`;

export const Column = styled(Flex)<{ gap?: number }>`
  flex-flow: column nowrap;
  ${(p) =>
    p.gap
      ? css`
          gap: ${p.gap}px;
        `
      : ''};
`;

export const CenteredColumn = styled(Flex)`
  flex-flow: column nowrap;
  align-items: center;
`;

export const DateTimeColumn = styled(Flex)`
  flex-flow: column nowrap;
  align-items: center;
  gap: 5px;
`;

export const FlexEndColumn = styled(Flex)`
  flex-flow: column nowrap;
  align-items: flex-end;
`;

export const FlexStartColumn = styled(Flex)`
  flex-flow: column nowrap;
  align-items: flex-start;
`;

export const FullWidthColumn = styled(Column)`
  width: 100%;
`;

export const RowWrap = styled(Row)`
  flex-wrap: wrap;
`;

export const Spacer = styled.div`
  flex: 1;
`;

export const AllBorderBox = css`
  box-sizing: border-box;

  * {
    box-sizing: border-box;
  }
`;

export const FlexHorizontalCenter = css`
  display: flex;
  justify-content: center;
  text-align: center;
`;
